import styled from "styled-components";
import { V3BodyCSS } from "../Typography";
import { InputMixin, InputStyleProps } from "../SharedInputComponent";
import {  theme } from "../../theme/theme";

export const V3FakeSelectWrapper = styled.div<{  $useHover?: boolean} & InputStyleProps>`
    position: relative;
    display: flex;
    align-items: center;
    ${V3BodyCSS};
    ${InputMixin};

    &:hover {
        cursor: pointer;
        background: ${({ theme, $useHover }) =>  $useHover ? theme.v3.colors.grey88 : null};
    }
`;

export const V3FakeSelectBrandingBarWrapper = styled(V3FakeSelectWrapper)`
    height: 63px;
`;

export const V3FakeIcon = styled.div<{ $disabled: boolean}>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    svg path,
    svg rect {
        stroke: ${({ theme, $disabled }) => {
           if ($disabled) return theme.v3.colors.grey88;
        }};
    }
`;

export const V3FakeSelectIcon = styled.div<{ $disabled: boolean}>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    display: inline-flex;

    svg path,
    svg rect {
        stroke: ${({ theme, $disabled }) => {
           if ($disabled) return theme.v3.colors.grey88;
        }};
    }
`

export const V3FakeSelectContent = styled.div<{ $hasContentSelected: boolean, $customPaddingLeft?: string, $disabled: boolean}>`
    padding-right: 40px;
    overflow: hidden;
    line-height: 25px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ $hasContentSelected }) => !$hasContentSelected ? theme.v3.colors.grey48 : undefined};
    padding-left: ${({ $customPaddingLeft }) => $customPaddingLeft ? $customPaddingLeft : undefined};
    color: ${({ $disabled }) => {
        if ($disabled) return theme.v3.colors.grey70;
    }};
`;

export const RuleFakeSelectorOperatorWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    max-width: 100%;
    margin-bottom: 20px;
    flex-direction: row;
    align-items: center;
    
    > div {
        &:first-child {
            width: calc(100% - 107px);
            margin-right: 12px;
        }

        &:nth-child(2) {
            margin-top: 12px;
            width: auto;
            flex-shrink: 0;
        }
    }
`;